import { render, staticRenderFns } from "./ProductInquiryReg.vue?vue&type=template&id=6ada4bfd&scoped=true"
import script from "./ProductInquiryReg.vue?vue&type=script&lang=js"
export * from "./ProductInquiryReg.vue?vue&type=script&lang=js"
import style0 from "./ProductInquiryReg.vue?vue&type=style&index=0&id=6ada4bfd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada4bfd",
  null
  
)

export default component.exports